import React from 'react';
import './StatusBadge.css';

/**
 * StatusBadge Component
 * 
 * A reusable component for displaying status badges with consistent styling
 * across the application (Tasks page, TasksDisplay component, etc.)
 * 
 * @param {string} status - The status value from the database
 * @param {string} className - Additional CSS classes (optional)
 * @param {object} style - Inline styles (optional)
 */
export default function StatusBadge({ status, className = '', style = {} }) {
  // Helper function to get CSS class for status
  const getStatusClass = (status) => {
    switch (status) {
      case 'Assigned':
        return 'pending';
      case 'In Progress':
        return 'in-progress';
      case 'Completed':
        return 'completed';
      case 'Canceled':
        return 'cancelled';
      default:
        return 'pending';
    }
  };

  // Format display text
  const getDisplayText = (status) => {
    if (!status) return 'Unknown';
    return status.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
  };

  if (!status) {
    return <span className="status-badge unknown">Unknown</span>;
  }

  return (
    <span 
      className={`status-badge ${getStatusClass(status)} ${className}`}
      style={style}
    >
      {getDisplayText(status)}
    </span>
  );
}